import React from 'react';

import CommonImage from '@/components/CommonImage';

const UpdateByerEtdModal = () => {
	return (
		<div className="popup-wrapper">
			<div className="common-popup material-request-details-modal update-buyer-etd-modal">
				<div className="common-popup-header d-flex justify-content-between">
					<div className="popup-tilte">
						<h3 className="semibold-14 mb-0">Updating Buyer ETD</h3>
					</div>
					<div className="close-btn">
						<img src="/icons/close.svg" alt="close" />
					</div>
				</div>
				<div className="common-popup-body scroll-y-label">
					<div className="choose-puprpose-box">
						<p className="regular-14 gray_dark_01 mb-2">Requested by*</p>
						<div className="row">
							<div className="col-md-12">
								<div className="d-flex justify-content-start gap-3 mb-12">
									<div className="custom-radio-box custom-radio">
										<div className="form-group d-flex align-items-center">
											<input type="radio" className="" id="purpose" name="purpose" />
											<label
												htmlFor="purpose"
												className="ml-2 mb-0 gray_dark_01 regular-14"
											>
												Buyer
											</label>
										</div>
									</div>
									<div className="custom-radio-box custom-radio">
										<div className="form-group d-flex align-items-center">
											<input type="radio" className="" id="2" name="purpose" />
											<label htmlFor="2" className="ml-2 mb-0 gray_dark_01 regular-14">
												Nitex
											</label>
										</div>
									</div>
									<div className="custom-radio-box custom-radio">
										<div className="form-group d-flex align-items-center">
											<input type="radio" className="" id="3" name="purpose" />
											<label htmlFor="3" className="ml-2 mb-0 gray_dark_01 regular-14">
												Factory
											</label>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-12">
								<div className="form-group mb-12">
									<div className="select-component">
										<label htmlFor="collection">Reason*</label>
										<div className="click-box click mb-1" data-toggle="dropdown">
											<p className="regular-14 ">select</p>
											<CommonImage src=" /images/chevron_down.svg" />
										</div>
										<div className="dropdown-box dropdown-menu">
											<div className="m-0 search-filter">
												<div className="with-icon right-icon">
													<input placeholder="Search" type="text" />
													<span className="right-icon">
														<img src=" /icons/search.png" />
													</span>
												</div>
											</div>
											<div className="list-items scroll-y-label">
												<div className="single-item">
													<p>Garments</p>
												</div>
												<div className="single-item">
													<p>Item 2</p>
												</div>
												<div className="single-item">
													<p>Item 3</p>
												</div>
												<div className="single-item">
													<p>Item 4</p>
												</div>
												<div className="single-item">
													<p>Item 5</p>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-12">
								<div className="form-group mb-12">
									<label htmlFor="multipleUpload">Attachments*</label>
									<div className="inline-upload">
										<label
											htmlFor="multipleUpload"
											className="regular-14 border-gray_dark_01"
										>
											<CommonImage src="/icons/upload-dark.svg" /> Upload
										</label>
										<input
											type="file"
											className="file-upload"
											id="multipleUpload"
											name="file"
											accept=".jpg,.jpeg,.png,application/pdf"
											multiple
										/>
									</div>
								</div>
								<div className="all-pdf-files d-flex flex-wrap justify-content-start align-items-center mb-12">
									<div className="single-pdf-file d-flex align-items-center mr-4">
										<CommonImage
											src="/images/file.svg"
											className="add-to-favorite"
											width={24}
										/>
										<a href="#" target="_blank" className="regular-14 ml-1">
											ChatGPT_Image_…
										</a>
										<div className="acton-img cursor-pointer ml-1">
											<CommonImage src="/icons/delete_red.svg" width={16} />
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-12">
								<div className="form-group mb-12">
									<label htmlFor="message">Message</label>
									<textarea rows="3" placeholder="Enter your message"></textarea>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="modal-footer">
					<div className="footer-buttons text-right">
						<button className="button outline size32 ml-2">Cancel</button>
						<button className="button size32 ml-2">Submit</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default UpdateByerEtdModal;
